(function () {

    "use strict";

    angular
        .module("parLabor")
        .component("parLaborMainListComponent", {
            controller: ParLaborMainListComponent,
            bindings: {
            },
            controllerAs: 'parLaborMainListComponent',
            templateUrl: '../hmodules/par-labor/components/par-labor-main-list/par-labor-main-list.component.html'
        });

    ParLaborMainListComponent.$inject = ['$q', 'TeamScheduleService', 'ParLaborDataService', '$filter', 'userServices', '$state'];

    function ParLaborMainListComponent ($q, TeamScheduleService, ParLaborDataService, $filter, userServices, $state) {

        var self = this;

        var LIMIT_DATE = moment('2018-08-01');

        var getWeekTitle = function (date, startWeekDate) {
            var weekDate = moment(date);
            var title = "";
            var weeksDifferenceInDays = weekDate.diff(startWeekDate, "day");
            var weeksDifference = Math.round(weeksDifferenceInDays / 7);

            if (weeksDifference === 0) {
                title = $filter("translate")("This week");

            } else if (weeksDifference === 1) {
                title = $filter("translate")("Next week");

            } else if (weeksDifference === -1) {
                title = $filter("translate")("Last week");

            } else if (weeksDifference > 0) {
                title = weeksDifference + " " + $filter("translate")("weeks ahead");

            } else {
                title = Math.abs(weeksDifference) + " " + $filter("translate")("weeks ago");
            }

            return title;
        };

        var getParForecasts = function (startWeekDate, startDate, endDate) {
            var defer = $q.defer();
            var parForecasts = [];

            ParLaborDataService
                .getParLaborForecasts(startDate, endDate)
                .then(function (forecasts) {
                    parForecasts = forecasts['par_forecasts'] || [];

                    // sort Par forecasts descending
                    parForecasts.sort(function (forecast_1, forecast_2) {
                        return moment(forecast_1.week).diff(moment(forecast_2.week)) > 0 ? -1 : 1;
                    });

                    for (var i in parForecasts) {
                        var weekForecast = parForecasts[i];

                        weekForecast.start_date = weekForecast.week;
                        weekForecast.end_date = moment(weekForecast.week).add(6, "days");
                        weekForecast.title = getWeekTitle(weekForecast.week, startWeekDate);
                    }

                    defer.resolve(parForecasts);

                }, function (err) {
                    console.error(err);
                });

            return defer.promise;
        };

        var init = function () {
            self.loading = true;
            self.parForecasts = [];

            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    self.brand = brand;
                    self.currency = $filter("locationCurrencySymbol")(self.brand);
                    self.startDayOfWeek = brand.startDayOfWeek;

                    self.startWeekDate = Utils.getWeekStart(moment(), self.startDayOfWeek);
                    self.startDate = Utils.getWeekStart(moment().subtract(6, "week"), self.startDayOfWeek);
                    var endDate = Utils.getWeekStart(moment().add(5, "week"), self.startDayOfWeek);

                    // for now specs required to set default date that we can return to past
                    if (self.startDate.isBefore(LIMIT_DATE)) {
                        self.startDate = Utils.getWeekStart(LIMIT_DATE, self.startDayOfWeek);
                        self.hideLoadMoreButton = true;
                    }

                    getParForecasts(self.startWeekDate, self.startDate, endDate)
                        .then(function (parForecasts) {
                            self.parForecasts = parForecasts;
                        })
                        .finally(function () {
                            delete self.loading;
                        });
                });
        };


        self.loadMoreParForecasts = function () {
            var endDate = moment(self.startDate).subtract(7, "days");
            self.startDate = moment(self.startDate).subtract(12, "week");

            if (self.startDate.isBefore(LIMIT_DATE)) {
                self.startDate = Utils.getWeekStart(LIMIT_DATE, self.startDayOfWeek);
                self.hideLoadMoreButton = true;
            }

            getParForecasts(self.startWeekDate, self.startDate, endDate)
                .then(function (parForecasts) {
                    self.parForecasts = self.parForecasts.concat(parForecasts);
                });
        };

        var updateDeletedForecast = function (forecast) {
            forecast.total_sales = null;
            forecast.food_sales_percentage = null;
            forecast.created = null;
            forecast.id = null;
        };

        self.deleteParForecast = function (index) {
            var forecast = self.parForecasts[index];

            if (forecast.id) {
                hConfirm({
                    title: $filter("translate")("Par Labor"),
                    text: $filter("translate")("Are you sure you want to delete PAR labor for this week?"),
                    callback: function (confirmed) {
                        if (confirmed) {
                            ParLaborDataService
                                .deleteParForecast(forecast.id)
                                .then(function (res) {
                                    updateDeletedForecast(forecast);

                                }, function (err) {
                                    console.error(err);
                                });
                        }
                    }
                });
            }
        };

        var onBrandChangedHandler = TeamScheduleService.onBrandChanged(function (brand, newBrand) {
            userServices
                .isServiceEnabled(userServices.SERVICES.PAR_LABOR, newBrand.id)
                .then(function (isParLaborServiceEnabled) {
                    if (isParLaborServiceEnabled) {
                        init();
                        delete self.hideLoadMoreButton;
                    } else {
                        $state.go("appLayout.schedule.main");
                    }
                });
        });

        self.$onInit = function () {
            init();
        };

        self.$onDestroy = function () {
            TeamScheduleService.off(onBrandChangedHandler);
        };
    }

})();